<template>
  <wx-open-launch-weapp
    :username="username"
    @launch="handleLaunchFn"
    @error="handleErrorFn"
    id="wxlink-launch"
    :path="wxPath"
  >
    <script type="text/wxtag-template">
      <style>
      .wxlink-box {
        opacity: 0;
      }
      </style>
      <div class="wxlink-box">测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试</div>
    </script>
  </wx-open-launch-weapp>
</template>

<script>
export default {
  props: {
    wxPath: {
      type: String,
      default: ""
    },
    username: {
      type: String,
      default: "gh_f208968c610c"
    }
  },
  data() {
    return {};
  },
  methods: {
    handleLaunchFn() {
      localStorage.setItem("openWechat", 1);
    },
    handleErrorFn() {}
  }
};
</script>

<style lang="scss" scoped>
#wxlink-launch {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 8;
  outline: none;
  height: 100%;
  display: flex;
  align-items: center;
  background: transparent;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/wxLink.vue